import { ChevronDownIcon } from "@heroicons/react/20/solid";
import { Badge } from "components/ui/badge";
import React from "react";

interface FilterPanelTriggerProps {
    icon: React.ReactNode;
    label: string;
    selectedCount: number;
    onOpen: () => void;
}

export const FilterPanelTrigger: React.FC<FilterPanelTriggerProps> = props => (
    <button
        type="button"
        className="flex items-center gap-1 cursor-pointer text-gray-700 lg:whitespace-nowrap rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-200"
        onClick={props.onOpen}>
        {props.icon}
        <span className="text-sm">{props.label}</span>
        {props.selectedCount > 0 ? (
            <Badge type="highlight" value={props.selectedCount} />
        ) : null}
        <ChevronDownIcon className="w-5 h-5 text-gray-500 flex-shrink-0" />
    </button>
);
